<script setup lang="ts">
import type { HTMLAttributes } from "vue";

import { cn } from "../../lib/utils";

interface Props {
  modelValue?: string | number;
  class?: HTMLAttributes["class"];
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  id?: string;
  name?: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: "update:modelValue", payload: string): void;
}>();

function onInput(event: Event) {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
}
</script>

<template>
  <input
    :id="id"
    :name="name"
    :type="type || 'text'"
    :value="modelValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :required="required"
    :class="cn('ui-input', props.class)"
    @input="onInput"
  />
</template>
